import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function NoResultsIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <path d="M92 92L118 118" stroke={c.p600} strokeWidth="12" />
      <circle cx="68" cy="68" r="32" fill={c.n0} stroke={c.p500} strokeWidth="8" />
      <circle cx="58" cy="62" r="3.5" fill={c.p400} />
      <circle cx="78" cy="62" r="3.5" fill={c.p400} />
      <path d="M56 82q12-9 24 0" stroke={c.p400} strokeWidth="4" />
    </Frame>
  );
}
